<script setup lang="ts">
import { ref } from 'vue'
import { mdiUpdate, mdiArrowRightBold, mdiProgressDownload } from '@mdi/js'
import { useVersionStore } from '../stores/version.store'
import SvgIcon from '@/shared/components/icon/SvgIcon.vue'
import PrimaryButton from '@/shared/components/button/PrimaryButton.vue'
import PromptDialog from '@/shared/components/dialog/PromptDialog.vue'

const versionStore = useVersionStore()
const currentVersion = ref<string>(__APP_VERSION__)

const updateNow = (): void => {
  versionStore.updateMode.isCritical = false
  location.reload()
}
</script>

<template>
  <PromptDialog :title="$t('glossary.applicationUpdate')" v-model:open="versionStore.updateMode.isCritical" class="text-center">
    <div class="flex justify-center">
      <SvgIcon :path="mdiProgressDownload" class="fill-success h-24 w-24" />
    </div>
    <div class="font-light text-gray-700 pt-4">{{ $t('message.newMandatoryUpdateAvailable') }}</div>
    <div class="flex items-center justify-center text-sm pt-2">
      <div>
        {{ $t('glossary.currentVersion') }}
        <span class="font-bold">{{ currentVersion }}</span>
      </div>
      <SvgIcon :path="mdiArrowRightBold" class="fill-success h-5 w-5 mx-1.5" />
      <div>
        {{ $t('glossary.newVersion') }}
        <span class="font-bold">{{ versionStore.version }}</span>
      </div>
    </div>
    <div class="p-4">
      <PrimaryButton
        :text="$t('glossary.updateNow')"
        :icon="mdiUpdate"
        class="w-full justify-center"
        @click="updateNow()"
      />
    </div>
  </PromptDialog>
</template>
